import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReviewedCountsResponse } from './get-reviewed-counts-response';
import { getReviewedCountsResponseSchema } from './get-reviewed-counts-response';

export async function getReviewedCountsApi(): Promise<
  IValidatedResponse<IGetReviewedCountsResponse>
> {
  return getRequest<IGetReviewedCountsResponse>({
    path: '/progress/reviewed-counts',
    schema: getReviewedCountsResponseSchema,
  });
}
